import { render } from "./CurrentProviderBio.vue?vue&type=template&id=7fad79b4&scoped=true"
import script from "./CurrentProviderBio.vue?vue&type=script&lang=js"
export * from "./CurrentProviderBio.vue?vue&type=script&lang=js"

import "./CurrentProviderBio.vue?vue&type=style&index=0&id=7fad79b4&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fad79b4"]])

export default __exports__